import { IRelationFactory } from "../factories/relation-factory";
import { EntityDefinitionMapper } from "../mappers/entity-definition-mapper";
import { EntityMapper } from "../mappers/entity-mapper";
import { IInternalClient } from "./internal-client";
import { IWebContentHubClient } from "./web-content-hub-client";

export interface IExtendedContentHubClient extends IWebContentHubClient {
    readonly internalClient: IInternalClient;
    readonly relationFactory: IRelationFactory;

    //#region Mappers
    readonly entityMapper: EntityMapper;
    readonly entityDefinitionMapper: EntityDefinitionMapper;
    //#endregion
}
